package br.com.texeratx.boardgametimeapp.ui.screens.players.edit

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.core.image.ImageSourcePickerDialog
import br.com.texeratx.boardgametimeapp.core.image.rememberImageSourceState
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class EditPlayerScreen(
    private val playerId: Long
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = koinInject<EditPlayerViewModel>()
        val state by viewModel.state.collectAsState()

        val imageSource = rememberImageSourceState { picked ->
            if (picked != null) viewModel.onImageSelected(picked)
        }

        ImageSourcePickerDialog(imageSource)

        LaunchedEffect(playerId) {
            viewModel.load(playerId)
        }

        EditPlayerUI(
            state = state,
            onValueChange = viewModel::updateState,
            onPickImage = imageSource.onLaunch,
            onClearImage = { viewModel.clearLocalImage() },
            onSave = { viewModel.save(playerId) { navigator.pop() } },
            onBack = { navigator.pop() }
        )
    }
}
